var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8925 4.5133C12.1613 4.65477 12.2645 4.98736 12.123 5.25616L8.91095 11.3591H11.6363C11.7959 11.3591 11.9476 11.4284 12.052 11.549C12.1565 11.6696 12.2034 11.8296 12.1807 11.9875L11.5741 16.1984L15.0276 10.4532H12.5933C12.2895 10.4532 12.0433 10.207 12.0433 9.90323C12.0433 9.59947 12.2895 9.35323 12.5933 9.35323H16C16.1982 9.35323 16.3811 9.4599 16.4787 9.63244C16.5763 9.80498 16.5735 10.0167 16.4713 10.1866L11.1125 19.1015C10.9776 19.3259 10.7032 19.4241 10.4566 19.3363C10.2099 19.2485 10.0594 18.9989 10.0967 18.7398L11.0014 12.4591H7.99995C7.80729 12.4591 7.62868 12.3583 7.52911 12.1934C7.42953 12.0284 7.42352 11.8234 7.51325 11.6529L11.1496 4.74384C11.2911 4.47504 11.6237 4.37182 11.8925 4.5133Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.449951 3.00001C0.449951 1.59169 1.59163 0.450012 2.99995 0.450012H21C22.4064 0.450012 23.55 1.58451 23.55 2.99473V20.25C23.55 20.5538 23.3037 20.8 23 20.8C22.6962 20.8 22.45 20.5538 22.45 20.25V2.99473C22.45 2.19581 21.8027 1.55001 21 1.55001H2.99995C2.19914 1.55001 1.54995 2.1992 1.54995 3.00001V21C1.54995 21.8008 2.19914 22.45 2.99995 22.45H21.3823C21.6861 22.45 21.9323 22.6963 21.9323 23C21.9323 23.3038 21.6861 23.55 21.3823 23.55H2.99995C1.59163 23.55 0.449951 22.4083 0.449951 21V3.00001Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricDevice);
export default __webpack_public_path__ + "static/media/electric_device.2c4d2346ccbed6b002135cd2eb55f88b.svg";
export { ForwardRef as ReactComponent };